import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { IPurchaseCSVErrors } from 'views/PurchaseViews/PurchaseUploaderHelper/IPurchaseCSVErrors';

export const usePurchaseUploadErrorsHeader = () => {
	const { add, build } = useTableColumnBuilder<IPurchaseCSVErrors>();

	add({
		id: () => "errors",
		name: "uploadErrorsTitle",
		headers: [
			{
				id: (c) => c.productClientID,
				key: "productClientID",
				name: "Product",
				maxWidth: "200px",
			},
			{
				id: (c) => c.storeClientID,
				key: "storeClientID",
				name: "Store",
				maxWidth: "200px",
			},
			{
				id: (c) => c.modifier.toString(),
				key: "modifier",
				name: "modifier",
				maxWidth: "100px",
			},
			{
				id: (c) => c.errorMessage,
				key: "errorMessage",
				name: "Error Message",
				maxWidth: "300px",
			},
		],
	});

	return {
		headers: build(),
	};
};

export default usePurchaseUploadErrorsHeader;
